/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var AttachLinkOffIcon16Solid = forwardRef('AttachLinkOffIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M2.207.793A1 1 0 0 0 .793 2.207l13 13a1 1 0 0 0 1.414-1.414l-1.554-1.554A5 5 0 0 0 11 3h-1a1 1 0 1 0 0 2h1a3 3 0 0 1 1.175 5.761L10.415 9H11a1 1 0 1 0 0-2H8.414L6.351 4.937A1 1 0 0 0 6 3H5c-.188 0-.373.01-.555.03L2.207.793Z" }),
        React.createElement("path", { d: "M0 8c0-1.35.535-2.575 1.404-3.474L2.82 5.94A3 3 0 0 0 5 11h1a1 1 0 1 1 0 2H5a5 5 0 0 1-5-5Z" })));
});
